import { Grid } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { Loader, NoData } from "../../components";
import CardItem from "../../components/CardItem";

const ExpertsGrid = ({ loading, experts, isEditable, onEdit }) => {
  const intl = useIntl();
  const history = useHistory();
  const onExpertClick = ({ id }) => () => {
    history.push(`/experts/${id}`);
  };

  return (
    <Loader loading={loading}>
      <NoData
        message={intl.formatMessage({
          id: "Shared.RecordingGrid.NoExpertData",
          defaultMessage: "There are no experts. Please check later for new contents..."
        })}
        data={experts}
      >
        <Grid container spacing={3}>
          {experts.map(({ id, publicName, shortDescription, publicAvatar }) => (
            <Grid item xs={12} sm={6} md={3} lg={2} key={id}>
              <CardItem
                title={publicName}
                description={shortDescription}
                thumbUrl={publicAvatar}
                onClick={onExpertClick({ id })}
                isEditable={isEditable}
                onEdit={e => {
                  onEdit(e, { id });
                  e.preventDefault();
                  e.stopPropagation();
                }}
                square
              />
            </Grid>
          ))}
        </Grid>
      </NoData>
    </Loader>
  );
};

export default ExpertsGrid;
